import { combineReducers } from 'redux';
import { RootAction } from '@src/app/_redux';
import {
  SEND_CUSTSERV_EMAIL_ERROR,
  SEND_CUSTSERV_EMAIL_START,
  SEND_CUSTSERV_EMAIL_SUCCESS,
  SEND_CUSTSERV_EMAIL_CANCEL,
  SEND_CUSTSERV_EMAIL_LOADING,
  SEND_EXCEPTION_EMAIL_ERROR,
  SEND_EXCEPTION_EMAIL_START,
  SEND_EXCEPTION_EMAIL_SUCCESS,
  SEND_EXCEPTION_EMAIL_CANCEL,
  SEND_EXCEPTION_EMAIL_LOADING,
} from '@src/app/accounts/customer-service/actions';

export interface EmailSentResult {
  success?: boolean;
  payload: any;
}

export type State = {
  readonly loading: boolean;
  sendEmailResult: EmailSentResult | null;
};

export const reducer = combineReducers<State, RootAction>({
  loading: (state = false, action) => {
    switch (action.type) {
      case SEND_CUSTSERV_EMAIL_ERROR:
      case SEND_CUSTSERV_EMAIL_SUCCESS:
      case SEND_CUSTSERV_EMAIL_CANCEL:
      case SEND_EXCEPTION_EMAIL_ERROR:
      case SEND_EXCEPTION_EMAIL_SUCCESS:
      case SEND_EXCEPTION_EMAIL_CANCEL:
        return false;
      case SEND_CUSTSERV_EMAIL_START:
      case SEND_CUSTSERV_EMAIL_LOADING:
      case SEND_EXCEPTION_EMAIL_START:
      case SEND_EXCEPTION_EMAIL_LOADING:
        return true;
      default:
        return state;
    }
  },

  sendEmailResult: (state = null, action) => {
    switch (action.type) {
      case SEND_CUSTSERV_EMAIL_SUCCESS:
      case SEND_CUSTSERV_EMAIL_ERROR:
      case SEND_EXCEPTION_EMAIL_SUCCESS:
      case SEND_EXCEPTION_EMAIL_ERROR:
        return action.payload;
      case SEND_CUSTSERV_EMAIL_CANCEL:
      case SEND_CUSTSERV_EMAIL_START:
      case SEND_EXCEPTION_EMAIL_CANCEL:
      case SEND_EXCEPTION_EMAIL_START:
        return null;
      default:
        return state;
    }
  },
});



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/accounts/customer-service/reducer.ts